import Axios from "axios";

export default function checkIfLoggedIn(std_id){
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'updateIsSubmit',
            std_id
        }
    });
    return response;
}